module.exports = __webpack_public_path__ + "static/media/loading-spinner-white.63b4bb35.svg";